export function simplifyPath(points, tolerance) {
    
    var douglasPeuckerReduction = function (points, firstPoint, lastPoint, tolerance, pointIndexsToKeep) {
        var maxDistance = 0;
        var indexFarthest = 0;
        for (var index = firstPoint; index < lastPoint; index++) {
            var distance = perpendicularDistance(points[firstPoint], points[lastPoint], points[index]);
            if (distance > maxDistance) {
                maxDistance = distance;
                indexFarthest = index;
            }
        }
        if (maxDistance > tolerance && indexFarthest != 0) {
            //Add the largest point that exceeds the tolerance
            pointIndexsToKeep.push(indexFarthest);
            douglasPeuckerReduction(points, firstPoint, indexFarthest, tolerance, pointIndexsToKeep);
            douglasPeuckerReduction(points, indexFarthest, lastPoint, tolerance, pointIndexsToKeep);
        }
        return pointIndexsToKeep;
    };

    var perpendicularDistance = function (point1, point2, point) {
        //Area = |(1/2)(x1y2 + x2y3 + x3y1 - x2y1 - x3y2 - x1y3)|   *Area of triangle
        //Base = v((x1-x2)²+(x1-x2)²)                               *Base of Triangle*
        //Area = .5*Base*H                                          *Solve for height
        //Height = Area/.5/Base

        var area = Math.abs(.5 * (point1.lng * point2.lat + point2.lng *
            point.lat +
            point.lng * point1.lat - point2.lng * point1.lat -
            point.lng *
            point2.lat - point1.lng * point.lat));
        var bottom = Math.sqrt(Math.pow(point1.lng - point2.lng, 2) +
            Math.pow(point1.lat - point2.lat, 2));
        var height = area / bottom * 2;

        return height;
    };

    if (points == null || points.length < 3) {
        return points;
    }

    var firstPoint = 0;
    var lastPoint = points.length - 1;
    var pointIndexsToKeep = new Array();

    //Add the first and last index to the keepers
    pointIndexsToKeep.push(firstPoint);
    pointIndexsToKeep.push(lastPoint);

    //The first and the last point cannot be the same
    while (points[firstPoint].lng == points[lastPoint].lng && points[firstPoint].lat == points[lastPoint].lat) {
        lastPoint--;
    }

    pointIndexsToKeep = douglasPeuckerReduction(points, firstPoint, lastPoint, tolerance, pointIndexsToKeep);

    var returnPoints = new Array();
    pointIndexsToKeep.sort(function (a, b) { return a - b; });

    for (var i = 0; i < pointIndexsToKeep.length; i++) {
        returnPoints.push(points[pointIndexsToKeep[i]]);
    }

    return returnPoints;

};


// WEBPACK FOOTER //
// ./src/api/douglaspeucker.js